import { render, staticRenderFns } from "./sidebar-pindaan.vue?vue&type=template&id=228387f4&"
import script from "./sidebar-pindaan.vue?vue&type=script&lang=js&"
export * from "./sidebar-pindaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports